import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const maxWidthClasses = {
    sm: 'max-w-[40rem]',
    md: 'max-w-[56rem]',
    lg: 'max-w-[72rem]',
    xl: 'max-w-[80rem]',
};
/* clamp() padding values cannot be expressed as static Tailwind classes */
const mainPaddingStyle = {
    padding: 'var(--sam-space-8) clamp(var(--sam-space-3), 3vw, var(--sam-space-4))',
};
const compactPaddingStyle = {
    padding: 'var(--sam-space-3) var(--sam-space-3)',
};
export function PageLayout({ title, children, maxWidth = 'lg', compact = false, }) {
    const mwClass = maxWidthClasses[maxWidth];
    // The app shell's content pane is the page surface (frosted glass), so the page paints no
    // background of its own and fills the pane rather than one screen height: a screen-tall
    // opaque canvas ended partway down a long page and showed as a seam once scrolled.
    return (_jsx("div", { className: `w-full min-w-0 flex-1 ${compact ? 'flex flex-col' : ''}`, children: _jsxs("main", { className: `${mwClass} mx-auto ${compact ? 'flex flex-col flex-1 min-h-0' : ''}`, style: compact ? compactPaddingStyle : mainPaddingStyle, children: [title && _jsx("h1", { className: "sr-only", children: title }), children] }) }));
}
//# sourceMappingURL=PageLayout.js.map